import React, { Component } from 'react';

export class Hero extends Component
{
	render() 
	{
		return (
			<div>
				<img src={this.props.logo} alt='Captivate Games logo' className='hero-logo' />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/Hero.js